import {Spinner} from "react-bootstrap";
import React, {useState} from "react";
import AppSettingController from "../../Main/controller/AppSettingController";
import StateModalModel from "../../../components/Modal/Model/StateModalModel";
import Confirm from "./Confirm";
import {ReactComponent as ArrowRightIcon} from './../assets/image/arrowRight.svg';
import InvoiceState from "../interface/invoiceState";
import MarketSetting from "../../Main/interface/MarketSettingLocalStorage";
import InvoiceController from "../Controller/InvoiceController";
import {useNavigate} from "react-router-dom";
import DiscountForm from "./DiscountForm";
import DiscountRow from "./DiscountRow";
import ShowDiscount from "./ShowDiscount";
import InvoiceInterface from "../interface/invoiceInterface";
import InvoiceTable from "./InvoiceTable";
import ModalComponents from "../../../components/Modal/Modal";
import DiscountController from "../Controller/DiscountController";
import SelectPaymentMethod from "./SelectPaymentMethod";
import AppCartController from "../../Main/controller/AppCartController";
import {useTranslation} from "react-i18next";

export default function InvoiceList({data, setData, state, setState}: {
    data: InvoiceState,
    setData: React.Dispatch<React.SetStateAction<InvoiceState>>,
    state: InvoiceInterface,
    setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>
}) {
    const {t, i18n} = useTranslation();
    const lang = i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR';
    const setting = AppSettingController.getSetting() as MarketSetting;
    const shopId = setting.id;
    const navigate = useNavigate();
    const desk = data.takeaway ? t("invoice.takeout") : data.deskActive?.label;
    const priceSumWithExtraCosts = AppCartController.priceSum(true);
    const currency = setting.currency || t("currency.default");

    const [stateModal, setStateModal] = useState<StateModalModel>({
        body: <Confirm state={state} setState={setState}/>,
        closeLabel: "",
        show: false,
        submit(): void {
        },
        submitLabel: "",
        title: "",
        modalClassName: "confirm",
        backdrop: 'static',
        bsPrefix: "confirm-background modal"
    })

    if (state.showPaymentMethod)
        return <SelectPaymentMethod state={state} setState={setState} data={data} setData={setData}/>

    return (
        <div className="invoice-container">
            <div className={'title'}>
                {setting.activeDesk ?
                    <ArrowRightIcon onClick={() => new InvoiceController(data, setData).backToSelectDesk()}/> : null}
                <h1>{t("invoice.title")}</h1>
            </div>
            <div className="top-table">
                <p>{t("invoice.receipt")} : <span>{setting.receipt}</span>
                    {setting.activeDesk ? <span> ({new InvoiceController(data, setData).getDeskName()})</span> : null}
                </p>
                <time>{t("date")}: {state.time.now} - {state.time.nowClock.slice(0, -3)}</time>
            </div>
            <div className={'payment-form'}>
                <InvoiceTable state={state} setState={setState}/>
            </div>
            {state.notAvailableProduct?.length ? <p className={'error-inventory'}>{t("invoice.notAvailableProduct")}</p> : null}
            <DiscountForm state={state} setState={setState}/>
            <div
                className={`footer-payment ${state.loading ? 'footer-payment-loading' : ''} ${state.discount.show || state.notAvailableProduct?.length ? 'mt-0' : 'mt-auto'}`}>
                {!state.loading ? <>
                    <ShowDiscount state={state} setState={setState}/>
                    <DiscountRow state={state} setState={setState}/>
                    <div className={`price ${state.discount.isApplyDiscount ? "align-items-start" : ""}`}
                         style={{display: AppSettingController.isHiddenPrice() ? 'none' : undefined}}>
                        <p>{t("invoice.priceToPay")}</p>
                        <div className="price-content">
                            <span>{currency}</span>
                            <div>
                                {state.discount.isApplyDiscount ? <span>
                                    {state.price.total.toLocaleString(lang)}
                                </span> : null}
                                <span className={state.discount.isApplyDiscount ? 'prev-price' : ''}>
                                      {priceSumWithExtraCosts.toLocaleString(lang)}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className={`actions ${AppSettingController.isHiddenPrice() ? 'mt-0' : ''}`}>
                        <button className={'refuse'}
                                onClick={() => setStateModal({...stateModal, show: true})}>
                            {t("cancel")}
                        </button>
                        <button className={'payment-btn'}
                                onClick={() => new DiscountController(state, setState).payment(shopId as string, navigate, desk)}>
                            {t("setting.payment")}
                        </button>
                    </div>
                </> : <div className={'loading'}>
                    <Spinner/>
                    {!AppSettingController.isActiveCart() ? <p>{t("invoice.paymentWaiting")}</p> : <p>{t("invoice.waitingAlert")}</p>}
                </div>}
            </div>
            <ModalComponents state={stateModal} setState={setStateModal}/>
        </div>
    );
}